// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"bf953887","453":"dc1bd338","683":"41f5e7d2"}[chunkId] + ".chunk.js";
};